"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_1bgns2mt95() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight16.tsx";
  var hash = "47077d29be0b696e1c1811c8909a8e1ebe480805";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight16.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 56
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "47077d29be0b696e1c1811c8909a8e1ebe480805"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1bgns2mt95 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1bgns2mt95();
var Icon = (cov_1bgns2mt95().s[0]++, {
  name: 'chevron-right-16',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.11612 2.11612C5.60427 1.62796 6.39573 1.62796 6.88388 2.11612L11.8839 7.11612C12.1183 7.35054 12.25 7.66848 12.25 8C12.25 8.33152 12.1183 8.64946 11.8839 8.88388L6.88388 13.8839C6.39573 14.372 5.60427 14.372 5.11612 13.8839C4.62796 13.3957 4.62796 12.6043 5.11612 12.1161L9.23223 8L5.11612 3.88388C4.62796 3.39573 4.62796 2.60427 5.11612 2.11612Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;